/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';

import {
  Box,
  Checkbox,
  Chip,
  ListItemText,
  OutlinedInput,
  Typography,
} from '@mui/material';
import {
  getNoteTypeDisplayName,
  NOTE_TYPE,
} from '../../../utils/enumHelper';
import { getIconForNoteType } from '../../NoteItem/NoteItem';

class NoteTypeSelectComponent extends React.Component {
  render() {
    const {
      onChange,
      value,
      includeAllOption,
      multiple,
      ...rest
    } = this.props;
    // Note, Medical, FeedChange, LocationChange, ProfileChange, Competition,

    return (
      <FormControl fullWidth margin="none" size="small">
        <InputLabel id="note-type-select-label">Note Type</InputLabel>
        <Select
          labelId="note-type-select-label"
          id="note-type-select"
          value={value}
          label="Note Type"
          input={<OutlinedInput label="Note Type" />}
          size="small"
          multiple={multiple}
          onChange={onChange}
          renderValue={(selected) => (
            <Box
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: 0.5,
              }}
            >
              {multiple
                ? selected.slice(0, 4).map((v) => (
                  <Chip
                    label={getNoteTypeDisplayName(v)}
                    key={v}
                    icon={getIconForNoteType(v)}
                    variant="filled"
                    size="small"
                    sx={{ margin: '0 !important' }}
                  />
                ))
                : (selected
                  ? (
                    <Chip
                      label={getNoteTypeDisplayName(selected)}
                      key={selected}
                      icon={getIconForNoteType(selected)}
                      variant="filled"
                      size="small"
                      sx={{ margin: '0 !important' }}
                    />
                  )
                  : <Box />)}
              {multiple && selected.length > 4 && <Typography>+{selected.length - 4} more</Typography>}
            </Box>
          )}
          {...rest}
        >
          {includeAllOption && <MenuItem value="">All</MenuItem>}
          {NOTE_TYPE.sort((a, b) => -b.label.localeCompare(a.label)).map((nt) => (
            <MenuItem key={`importance-menu-item-${nt.enum}`} value={nt.enum}>
              <Checkbox checked={value === nt.enum || value.indexOf(nt.enum) > -1} />
              <ListItemText primary={getNoteTypeDisplayName(nt.label)} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }
}

NoteTypeSelectComponent.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.any,
  includeAllOption: PropTypes.bool,
  multiple: PropTypes.bool,
};

NoteTypeSelectComponent.defaultProps = {
  onChange: () => { },
  value: null,
  includeAllOption: false,
  multiple: false,
};

export default (NoteTypeSelectComponent);
